import { ButtonHTMLAttributes, ReactNode } from 'react';
import { CircleNotchIcon } from '@phosphor-icons/react';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  loading?: boolean;
}

export const PrimaryButton = ({
  children,
  loading = false,
  disabled,
  className = '',
  ...props
}: PrimaryButtonProps) => {
  return (
    <button
      disabled={disabled || loading}
      className={`w-full bg-primary text-white font-medium py-3 px-6 rounded-lg hover:bg-opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${className}`}
      {...props}
    >
      {loading && <CircleNotchIcon size={20} className="animate-spin" weight="bold" />}
      {children}
    </button>
  );
};
